import MainTitle from '../common/MainTitle';
import Icon from '../common/Icon';
import ImageLink from '../../js/utils/ImageLink';

export default function HeroSection({ data }) {
  return (
    <section
      className="careers-hero-section"
      style={{ backgroundImage: `url(${ImageLink(data?.image?.url)})` }}>
      <div className="container">
        <div class="overlay"></div>
        <div className="careers-hero-section__content">
          <MainTitle type="light" className="text--2xl hidden--lg">
            <span>{data?.title1}</span>
            <span className="decorated-line decorated-line--light decorated-line--left">
              {data?.title2}
            </span>
            <span>{data?.title3}</span>
          </MainTitle>

          <div className="careers-hero-section__content-container">
            <MainTitle type="light" className="text--2xl hidden--md">
              <span>{data?.title1}</span>
              <span className="decorated-line decorated-line--light decorated-line--left">
                {data?.title2}
              </span>
              <span>{data?.title3}</span>
            </MainTitle>
          </div>
        </div>

        <a target="_blank" href={data?.actionLink} className="button action-button">
          <Icon name="open-light" />
          <span>{data?.actionText}</span>
        </a>
      </div>
    </section>
  );
}
